import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckBroken = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.6 12a9.6 9.6 0 1 1-19.2 0A9.6 9.6 0 0 1 12 2.4c1.506 0 2.931.347 4.2.965M19.8 6l-8.4 8.4L9 12"
    />
  </svg>
);
export default SvgCheckBroken;
